import { PrimaryNavItem } from '../models';

export const APP_NAV_ITEMS: PrimaryNavItem[] = [
  { id: 'dashboard', label: 'DASHBOARD', iconClass: 'rc-icon-home', link: '/dashboard' },
  { id: 'clients', label: 'CLIENTS', iconClass: 'rc-icon-store', link: '/clients' },
  { id: 'suppliers', label: 'SUPPLIERS', iconClass: 'rc-icon-skyscraper', link: '/suppliers' },
  {
    id: 'sales',
    label: 'SALES',
    iconClass: 'rc-icon-sales-invoice',
    link: '/sales/overview',
    children: [
      { label: 'CLIENT_QUOTES', link: '/sales/client_quotes' },
      { label: 'CLIENT_DOCUMENTS', link: '/sales/client_documents' },
      { label: 'CLIENT_ORDERS', link: '/sales/orders' },
      { label: 'CLIENT_INVOICES', link: '/sales/client_invoices' },
      { label: 'CLIENT_CREDIT_NOTES', link: '/sales/client_credit_notes' },
      { label: 'CLIENT_RETURNS', link: '/sales/client_returns' },
      { label: 'STOCK_SALES_REPORTS', link: '/sales/stock_sales_reports' },
    ],
  },
  {
    id: 'purchase',
    label: 'PURCHASE',
    iconClass: 'rc-icon-purchase-invoice',
    link: '/purchase/overview',
    children: [
      { label: 'ORDERS', link: '/purchase/supplier_orders' },
      { label: 'SUPPLIER_DOCUMENTS', link: '/purchase/supplier_documents' },
      { label: 'SUPPLIER_INVOICES', link: '/purchase/supplier_invoices' },
      { label: 'SUPPLIER_CREDIT_NOTES', link: '/purchase/supplier_credit_notes' },
      { label: 'SUPPLIER_COMPLAINTS', link: '/purchase/supplier_complaints' },
    ],
  },
  { id: 'articles', label: 'ARTICLES', iconClass: 'rc-icon-microwave', link: '/supplier_articles' },
  { id: 'warehouse', label: 'WAREHOUSE', iconClass: 'rc-icon-warehouse', link: '/warehouse' },
  { id: 'complaints', label: 'COMPLAINTS', iconClass: 'rc-icon-message-exclamation', link: '/complaints' },
  { id: 'intranet', label: 'INTRANET', iconClass: 'rc-icon-folders', link: '/document_library_folders' },
  { id: 'communication', label: 'COMMUNICATION', iconClass: 'rc-icon-speakerphone', link: '/communication' },
  { id: 'files', label: 'FILES', iconClass: 'rc-icon-files', link: '/user_medias' },
  { id: 'employees', label: 'EMPLOYEES_RC', iconClass: 'rc-icon-employee', link: '/royal_crown_employees' },
  { id: 'settings', label: 'SETTINGS', iconClass: 'rc-icon-settings', link: '/settings' },
  {
    id: 'logs',
    label: 'LOGS',
    iconClass: 'rc-icon-file-text',
    link: '/logs',
    children: [
      {
        label: 'PEPPOL',
        link: '/logs/peppol',
        id: 'peppol',
        iconClass: 'rc-icon-file-peppol',
        children: [
          {
            label: 'CLIENT_INVOICE_LOGS',
            link: '/logs/peppol/client_invoice_peppol_logs',
          },
          {
            label: 'CLIENT_CREDIT_NOTE_LOGS',
            link: '/logs/peppol/client_credit_note_peppol_logs',
          },
        ],
      },
    ],
  },
];
